import React from "react";
import { getCreditText, isUserEmployer } from "../../../helpers/common";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const UsersWallet = () => {
  const { profile } = useSelector((state) => state.customer);
  const { planDetails, isPlanLoading } = useSelector((state) => state.employer);
  
  if (!isUserEmployer(profile)) return null;

  const creditBalance = planDetails?.balance || 0;
  const hasPlan = planDetails && Object.keys(planDetails).length > 0;
  const isPlanExpired = planDetails?.is_expired || false;
  const shouldRedirectToPricing = !hasPlan || creditBalance === 0;
  
  const getWalletContent = () => {
    if (isPlanLoading) {
      return (
        <div className="d-flex flex-column">
          <div className="bg-white bg-opacity-75" style={{ width: "25px", height: "12px", borderRadius: "3px", animation: "pulse 1.5s ease-in-out infinite" }}></div>
          <div className="bg-white bg-opacity-75" style={{ width: "35px", height: "8px", borderRadius: "3px", marginTop: "2px", animation: "pulse 1.5s ease-in-out infinite" }}></div>
        </div>
      );
    }

    if (!hasPlan) {
      return (
        <div className="d-flex flex-column">
          <span className="fw-bold text-white" style={{ fontSize: "11px" }}>No Plan</span>
          <span className="text-light" style={{ fontSize: "10px" }}>Get Started</span>
        </div>
      );
    }

    if (isPlanExpired) {
      return (
        <div className="d-flex flex-column">
          <span className="fw-bold text-white" style={{ fontSize: "11px" }}>{creditBalance}</span>
          <span className="text-light" style={{ fontSize: "10px" }}>Expired</span>
        </div>
      );
    }

    return (
      <div className="d-flex flex-column">
        <span className="fw-bold text-light" style={{ fontSize: "11px" }}>{creditBalance}</span>
        <span className="text-light" style={{ fontSize: "10px" }}>{getCreditText(creditBalance)} left</span>
      </div>
    );
  };

  const getBackgroundClass = () => {
    if (isPlanLoading) return "wallet-icon-loading";
    if (!hasPlan || creditBalance === 0 || isPlanExpired) return "bg-danger";
    return "";
  };

  return (
    <li className="position-relative ms-1 me-3 h-100 d-none d-sm-block">
      <Link className="primary-link fs-13" to={shouldRedirectToPricing ? "/pricing" : "/employer/dashboard"}>
        <div className={`d-flex align-items-center wallet-icon ${getBackgroundClass()}`}>
          <i className="mdi mdi-wallet"></i>
          <span className="ms-2">{getWalletContent()}</span>
        </div>
      </Link>
    </li>
  );
};

export default UsersWallet;
